<template>
  <div class="grid row">
    <div class="flex xs12 md12">
      <va-card>
        <div>
          <va-card-content>
            <div style="color:rgba(0,0,0,0.85);text-align: center;font-weight: bold;font-size: 28px">
              <span>{{ voteHead.topic }}</span></div>
            <div style="color:darkslateblue;font-weight: bold" v-if="voteHead.slogan"><span>{{
                voteHead.slogan
              }}</span></div>
            <div style="color:#FF3333;font-weight: bold" v-if="voteHead.remark">投票说明：<span>{{
                voteHead.remark
              }}</span></div>
            <div style="display: flex;flex-direction: row;justify-content: space-between;">
              <div style="color:gray">投票时间：<span>{{ getShortTime(voteHead.beginTime) }}</span> 至
                <span>{{ getShortTime(voteHead.endTime) }}</span>
              </div>
              <div><a href="#" @click="showRanking">查看投票结果</a></div>
            </div>
          </va-card-content>
        </div>
      </va-card>
    </div>
    <!-- <va-inner-loading :loading="isLoading" style="width: 100%;"  color="primary"> -->
    <div class="flex xs12 md12">
      <va-card>
        <va-card-content>
          <vote-list-card></vote-list-card>
        </va-card-content>

      </va-card>
    </div>
  </div>
  <vxe-modal title="投票结果" v-model="isShowDashbord" width="1000" height="620" maskClosable show-zoom resize>
    <template #default>
      <Ranking v-if="isShowDashbord"></Ranking>
    </template>
  </vxe-modal>
</template>
<script>
import {computed, defineComponent, ref, reactive} from 'vue';
import {VXETable, VxeTableInstance, VxeTablePropTypes} from 'vxe-table'
import VoteListCard from './components/VoteListCard'
import Qs from 'qs';
import Ranking from './components/Ranking'

export default defineComponent({
  name: "vote",
  components: {VoteListCard, Ranking},
  data() {

    return {
      voteHead: {},
      tableData: null,
      isShowDashbord: false
    }
  },
  methods: {
    find() {
      const params = {
        'uid': this.$store.state.userID,
        'email': this.$store.state.email,
        'currentPage': 1,
        'pageSize': 20,
        'searchKey': []
      };
      this.$api.voteAPI.getVoteCurrentHead(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({content: res.data.Message, status: 'error'});
            return;
          }
          this.voteHead = res.data.Data[0];

        })
        .catch(error => {
          console.log(error);

        })
    },
    getShortTime(longTime) {
      if (longTime) {
        return longTime.substring(0, 16).replace('T',' ');
      }
    },
    showRanking() {
      this.isShowDashbord = true;
    }
  },
  mounted() {
    this.find();
  }

})
</script>

<style lang="scss">

</style>
